import type { Recipe, Video } from "./types";

export const CHANNEL_URL = "https://www.youtube.com/@klopotenko";
export const SITE_URL = "https://klopotenko.com";

const yt = (id: string) => `https://www.youtube.com/watch?v=${id}`;
const shorts = (id: string) => `https://www.youtube.com/shorts/${id}`;
const thumb = (id: string) => `https://i.ytimg.com/vi/${id}/hq720.jpg`;

export const fallbackVideos: Video[] = [
  {
    id: "jTz6aBR-GJ4",
    title: "НЕ ВАРІТЬ ГАРБУЗ. Приготуйте його так, як ніколи раніше",
    description: "Осінній випуск із трьома ідеями для гарбуза: закуска, вареники та крем-брюле.",
    category: "Сезонне",
    kind: "episode",
    published: "2026-09-23T16:13:47+00:00",
    views: 27186,
    duration: "24 хв",
    thumbnail: thumb("jTz6aBR-GJ4"),
    sourceUrl: yt("jTz6aBR-GJ4")
  },
  {
    id: "PZ6P1iqyphM",
    title: "КІМЧІ: страва, без якої немає корейського столу. Клопотенко & Лім",
    description: "Розмова про корейську кухню в Україні та рецепт справжнього кімчі.",
    category: "Кухні світу",
    kind: "episode",
    published: "2026-09-16T16:29:04+00:00",
    views: 108506,
    duration: "36 хв",
    thumbnail: thumb("PZ6P1iqyphM"),
    sourceUrl: yt("PZ6P1iqyphM")
  },
  {
    id: "bgF41IjO8dE",
    title: "Чому в Україні немає десертів? Клопотенко & Брайченко",
    description: "Історична розмова про солодке, локальні традиції та гастрономічну пам'ять.",
    category: "Гастроспадок",
    kind: "special",
    published: "2026-09-12T14:33:41+00:00",
    views: 65772,
    duration: "41 хв",
    thumbnail: thumb("bgF41IjO8dE"),
    sourceUrl: yt("bgF41IjO8dE")
  },
  {
    id: "5pul4HVdIAA",
    title: "Чому ми готуємо печені яблука саме так? 3 найсмачніші рецепти",
    description: "Три способи приготувати печені яблука для домашнього осіннього меню.",
    category: "Десерти",
    kind: "episode",
    published: "2026-09-04T16:54:52+00:00",
    views: 27894,
    duration: "18 хв",
    thumbnail: thumb("5pul4HVdIAA"),
    sourceUrl: yt("5pul4HVdIAA")
  },
  {
    id: "SWjDeK9W1UA",
    title: "Не готуйте так картоплю: 5 поширених помилок",
    description: "Практичний випуск про текстуру, температуру та помилки у приготуванні картоплі.",
    category: "Поради",
    kind: "episode",
    published: "2026-08-31T14:00:13+00:00",
    views: 269930,
    duration: "16 хв",
    thumbnail: thumb("SWjDeK9W1UA"),
    sourceUrl: yt("SWjDeK9W1UA")
  },
  {
    id: "8JX72GmPMww",
    title: "Хмельниччина: ковбаса, білий борщ, фляки з печі і начинка",
    description: "Велика гастрономічна експедиція про локальні рецепти та українську спадщину.",
    category: "Гастроспадок",
    kind: "special",
    published: "2026-08-15T15:00:00+00:00",
    views: 150000,
    duration: "52 хв",
    thumbnail: thumb("8JX72GmPMww"),
    sourceUrl: yt("8JX72GmPMww"),
    recipeUrl: "https://klopotenko.com/gastrospadok"
  },
  {
    id: "-7AayTChOYY",
    title: "Маєте черствий хліб? Зробіть з нього це",
    description: "Швидкий vertical рецепт для перетворення вчорашнього хліба на десерт.",
    category: "Shorts",
    kind: "short",
    published: "2026-09-18T11:00:22+00:00",
    views: 59727,
    duration: "Short",
    thumbnail: thumb("-7AayTChOYY"),
    sourceUrl: shorts("-7AayTChOYY")
  },
  {
    id: "qrNZ7K396dc",
    title: "Часникове масло - це краще, ніж ви очікуєте",
    description: "Короткий рецепт для швидкого апгрейду домашніх страв.",
    category: "Shorts",
    kind: "short",
    published: "2026-09-13T12:00:00+00:00",
    views: 24627,
    duration: "Short",
    thumbnail: thumb("qrNZ7K396dc"),
    sourceUrl: shorts("qrNZ7K396dc")
  },
  {
    id: "7BAXxbGA3vE",
    title: "Морозиво всього з двох складників",
    description: "Легкий короткий рецепт для літнього або сімейного меню.",
    category: "Shorts",
    kind: "short",
    published: "2026-09-08T12:00:16+00:00",
    views: 64666,
    duration: "Short",
    thumbnail: thumb("7BAXxbGA3vE"),
    sourceUrl: shorts("7BAXxbGA3vE")
  },
  {
    id: "vq5tsmjWDsE",
    title: "Снек із кукурудзи. Просто спробуйте це",
    description: "Формат для короткого перегляду і швидкого повторення на кухні.",
    category: "Shorts",
    kind: "short",
    published: "2026-09-01T12:00:28+00:00",
    views: 72841,
    duration: "Short",
    thumbnail: thumb("vq5tsmjWDsE"),
    sourceUrl: shorts("vq5tsmjWDsE")
  }
];

export const fallbackRecipes: Recipe[] = [
  {
    id: "prostyj-marynad-dlya-grybiv",
    title: "Простий маринад для грибів на 1 літр води",
    category: "Кулінарні лайфхаки",
    image: "https://klopotenko.com/wp-content/uploads/2026/09/bilyh-grybu-img.jpeg",
    url: "https://klopotenko.com/prostyj-marynad-dlya-grybiv-na-1-litr-vody-proporcziyi-ta-reczept-vid-yevgena-klopotenka/",
    readingTime: "6 хв"
  },
  {
    id: "yak-zapekty-kapustu",
    title: "Як запекти капусту, щоб вона була рум'яною та соковитою",
    category: "Поради",
    image: "https://klopotenko.com/wp-content/uploads/2026/09/yak-zapekty-kapustu-img.jpg",
    url: "https://klopotenko.com/yak-zapekty-kapustu-v-duhovczi-shhob-vona-bula-rumyanoyu-zovni-ta-sokovytoyu-vseredyni-porady-ta-reczepty/",
    readingTime: "7 хв"
  },
  {
    id: "bryusselska-kapusta",
    title: "Чим корисна брюссельська капуста та як її приготувати",
    category: "Здорове харчування",
    image: "https://klopotenko.com/wp-content/uploads/2026/09/brysselska_kapysta_klopotenko_6-1-img.jpg",
    url: "https://klopotenko.com/chym-korysna-bryusselska-kapusta-ta-yak-yiyi-prygotuvaty-smachno-porady-yevgena-klopotenka/",
    readingTime: "5 хв"
  },
  {
    id: "folga-produkty",
    title: "Помідори, лимони та ще 3 продукти: що не радять загортати у фольгу",
    category: "Поради",
    image: "https://klopotenko.com/wp-content/uploads/2026/09/fresh-vegetables-and-wrap-ready-to-grill-img.jpg",
    url: "https://klopotenko.com/pomidory-lymony-ta-shhe-3-produkty-shho-naukovczi-ne-radyat-zagortaty-u-folgu/",
    readingTime: "5 хв"
  }
];

export const categoryFilters = [
  "Усе",
  "Сезонне",
  "Гастроспадок",
  "Кухні світу",
  "Десерти",
  "Поради",
  "Shorts"
];
